/**
 * DefaultSettingsPage duck
 * Store default language is persisted via updateProfile (ProfileSettingsPage.duck).
 * This duck only provides loadData for the route.
 */
export const loadData = () => () => Promise.resolve();
